import { Modal, Space, Spin } from "antd";
import React, { Component } from "react";
import ButtonItem from "./ButtonItem";


class ModalItem extends Component {
  render() {
    const width = window.innerWidth > 1000 ? "60%" : "95%";
    const {
      footer,
      onOk,
      onCancel,
      confirmLoading,
      okText = "OK",
      cancelText = "Cancelar",
    } = this.props;

    const resetKey = this.props.visible ? Date.now() : null;

    return (
      <Modal
        {...this.props}
        width={this.props.width || width}
        footer={
          footer
            ? (
              <Space>
                <ButtonItem danger onClick={onCancel}>
                  {cancelText}
                </ButtonItem>
                <ButtonItem
                  type="primary"
                  onClick={onOk}
                  disableWhenClick
                  resetKey={resetKey}
                  loading={confirmLoading}
                >
                  {okText}
                </ButtonItem>
              </Space>
            )
            : null
        }
        bodyStyle={
          this.props.paddingTop
            ? { padding: 0, paddingTop: 10 }
            : { padding: 0 }
        }
        style={{
          borderRadius: '10px',
          overflow: 'hidden',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Spin spinning={!!this.props.spinning} size="large">
          <div style={{ padding: "0 24px 5px 24px" }}>
            {this.props.children}
          </div>
        </Spin>
      </Modal>
    );
  }
}

export default ModalItem;
